// Copied from: https://github.com/lunaticmonk/great-circle-distance/commit/39733b7e4c0e2a126625d39dfc3723cd287492aa
// Changes: Greek letters are replaced to their western literal form
"use strict";


const PI = Math.PI;
const RADIUS_OF_EARTH = 6371e3;

export const greatCircleDistance = options => {
  const { lat1, lng1, lat2, lng2 } = options;

  const dLat = getRadians(lat2) - getRadians(lat1);
  const dLng = getRadians(lng2) - getRadians(lng1);

  const phi1 = getRadians(lat1);
  const phi2 = getRadians(lat2);
  const deltaPhi = getRadians(lat2 - lat1);
  const deltaLambda = getRadians(lng2 - lng1);

  /**
   * Havershine's formula
   *
   */

  const a =
    Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
    Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = RADIUS_OF_EARTH * c;

  // distance in kms.
  return d / 1000;
};

const getRadians = coordinate => {
  return (coordinate * PI) / 180;
};
